
import useWeb3 from "../useWeb3";
import { getTrade } from "../../utils/contractHelpers";
import { useRecoilValue } from "recoil";
import { userSmartAccount } from "../../components/RecoilAtom";
import { useCallback } from "react";

const useClaimEligibility = () => {
    const smartAccount = useRecoilValue(userSmartAccount)
    const web3 = useWeb3();

    const checkClaimEligibility = useCallback(async (address) => {
        const contract = getTrade(address, web3);
        try {
            const disputeWindowTimer = await contract.methods.DISPUTE_WINDOW().call();
            return disputeWindowTimer;
        } catch (error) {
            console.error("Error fetching timer:", error.message || error);
            throw error;
        }
    },
        [web3, smartAccount]
    );
    return { checkClaimEligibility };
};

export default useClaimEligibility;